document.addEventListener("DOMContentLoaded", () => {
  // Busca todos los carruseles de marcas (por si hay más de uno)
  const carousels = document.querySelectorAll("slideshow-component.resource-list__carousel");

  carousels.forEach((carousel) => {
    const scroller = carousel.querySelector('[ref="scroller"]');
    if (!scroller) return;

    let paused = false;

    // Pausar en hover/touch para no pelear con el usuario
    carousel.addEventListener("mouseenter", () => (paused = true));
    carousel.addEventListener("mouseleave", () => (paused = false));
    carousel.addEventListener("touchstart", () => (paused = true), { passive: true });
    carousel.addEventListener("touchend", () => (paused = false), { passive: true });

    setInterval(() => {
      if (paused) return;

      scroller.scrollBy({ left: 220, behavior: "smooth" });

      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 5;
      if (atEnd) scroller.scrollTo({ left: 0, behavior: "smooth" });
    }, 2000);
  });
});
